import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { ScreenResolutionService } from '@app/core/services/screen-resolution/screen-resolution.service';
import { LdLoggerNoiseSoundSignalLoadComponent } from '@app/main/leak-detection/components/ld-helper/ld-logger-noise-sound-signal-load/ld-logger-noise-sound-signal-load.component';
import { selectAllLoggerMeasurements } from '@app/main/main-screen/store/data/logger-measurements/logger-measurements.selectors';
import { Store } from '@ngrx/store';
import { TranslateDirective } from '@ngx-translate/core';
import { LdDataTimedService } from '@app/main/leak-detection/services/leak-detection-data-timed/leak-detection-data-timed.service';

@Component({
  selector: 'gc-fp-load-sound-signals-action',
  standalone: true,
  imports: [LdLoggerNoiseSoundSignalLoadComponent, TranslateDirective],
  templateUrl: './fp-load-sound-signals-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FpLoadSoundSignalActionComponent {
  protected readonly store = inject(Store);
  public readonly scrRes = inject(ScreenResolutionService);
  public readonly ldDataTimedService = inject(LdDataTimedService);

  public firstLoggerDeploymentId = input.required<string | null>();
  public secondLoggerDeploymentId = input.required<string | null>();

  private allLoggerMeasurements = this.store.selectSignal(selectAllLoggerMeasurements);

  private firstActualMeasurement = computed(() => {
    const firstLoggerDeploymentId = this.firstLoggerDeploymentId();
    if (!firstLoggerDeploymentId) return null;
    const relatedMeasurements = this.allLoggerMeasurements().filter(
      loggerMeasurement => loggerMeasurement.deploymentId === firstLoggerDeploymentId
    );
    // TODO previously was only one measurement, now we have a lot, so decided to get actual by date but this logic should be checked, check for secondSoundSignalUrl too
    return this.ldDataTimedService.getActualMeasurement(relatedMeasurements) || null;
  });

  private secondActualMeasurement = computed(() => {
    const secondLoggerDeploymentId = this.secondLoggerDeploymentId();
    if (!secondLoggerDeploymentId) return null;
    const relatedMeasurements = this.allLoggerMeasurements().filter(
      loggerMeasurement => loggerMeasurement.deploymentId === secondLoggerDeploymentId
    );
    return this.ldDataTimedService.getActualMeasurement(relatedMeasurements) || null;
  });

  public firstSoundSignalUrl = computed(() => this.firstActualMeasurement()?.soundSignalUrl || null);
  public firstLoggerSoundSignalId = computed(() => this.firstActualMeasurement()?.soundSignalId || null);

  public secondSoundSignalUrl = computed(() => this.secondActualMeasurement()?.soundSignalUrl || null);
  public secondLoggerSoundSignalId = computed(() => this.secondActualMeasurement()?.soundSignalId || null);
}
